import { styled } from "styled-components";

export const ClassScheduleTooltipContainer = styled.div`
  max-width: 300px;
`;

export const TooltipHeading = styled.h3``;
